module.exports = __webpack_public_path__ + "static/img/banner_img.34393fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/banner_img.png
// module id = Lt7E
// module chunks = 0